import { render, staticRenderFns } from "./wali.vue?vue&type=template&id=610b75e9"
import script from "./wali.vue?vue&type=script&lang=js"
export * from "./wali.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreAppBar: require('/app/components/core/AppBar.vue').default,CoreView: require('/app/components/core/View.vue').default,CoreFooter: require('/app/components/core/Footer.vue').default})
